import React, { useMemo, useState } from "react";
import { StreamProvider } from "@teamrota/shiftstreamlib";

import ShiftStream from "../..";
import Icon, { ICON_NAMES as Icons } from "~/src/components/icon";
import { useAccounts } from "../../graphql/use-accounts";
import Table from "./Table";
import { FilterSelect, RefreshButton } from "../styles";
import { getFilterableProviders, getProviderLabel } from "../../utils";

export const COL_WIDTHS = [
  "6vw",
  "19vw",
  "8vw",
  "11vw",
  "11vw",
  "11vw",
  "11vw",
  "8vw",
];

export const Home = () => {
  const { accounts, loading, refetch } = useAccounts();
  const [providerFilter, setProviderFilter] = useState<"all" | StreamProvider>(
    "all",
  );
  const providerOptions = getFilterableProviders() as StreamProvider[];

  const filteredAccounts = useMemo(() => {
    if (providerFilter === "all") {
      return accounts;
    }

    return accounts.filter(
      (account: any) => account.provider === providerFilter,
    );
  }, [accounts, providerFilter]);

  const handleRefresh = () => {
    refetch();
  };

  return (
    <ShiftStream>
      <div
        style={{
          width: "87vw",
          marginBottom: 16,
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        <FilterSelect
          id="stream-provider-filter"
          value={providerFilter}
          onChange={(e) =>
            setProviderFilter(
              e.target.value === "all"
                ? "all"
                : (e.target.value as StreamProvider),
            )
          }
        >
          <option value="all">All Providers</option>
          {providerOptions.map((provider) => (
            <option key={provider} value={provider}>
              {getProviderLabel(provider)}
            </option>
          ))}
        </FilterSelect>

        <RefreshButton
          type="button"
          aria-label="Refresh"
          title="Refresh"
          disabled={loading}
          onClick={handleRefresh}
          style={{ marginLeft: 0, flexShrink: 0 }}
        >
          <Icon
            name={Icons.REFRESH}
            size={18}
            color={loading ? Icon.colors.GREY_DARK : Icon.colors.MAIN_ORANGE}
            onClick={handleRefresh}
          />
        </RefreshButton>
      </div>

      <Table accounts={filteredAccounts} loading={loading} />
    </ShiftStream>
  );
};

export default Home;
